import type { QueryClient } from '@tanstack/react-query';
import type { Me } from './auth-api';
import { ME_QUERY_KEY } from './session';

/**
 * The API said the demo period ended (`403 DEMO_EXPIRED`): the cached session agrees from now
 * on, so the shell swaps every screen for the "demo ended" notice at once. A session that did
 * not know about a demo yet is read again.
 */
export function handleDemoExpired(queryClient: QueryClient): void {
  const me = queryClient.getQueryData<Me>(ME_QUERY_KEY);
  if (me?.demo) {
    queryClient.setQueryData<Me>(ME_QUERY_KEY, { ...me, demo: { ...me.demo, expired: true } });
    return;
  }
  void queryClient.invalidateQueries({ queryKey: ME_QUERY_KEY });
}
